import React from "react";
import './student-clicker-list.scss';
import { getImageSource } from "../../../../../utility/image-source";
import { ImageConstants } from "../../../../../constants/constants";
import CommonUtils from "../../../../../utility/common-utilities";

class StudentClickerList extends React.Component {

    state = {
        // studentList: [
        //     {
        //         teacherUserId: '659b90fa21cb4f53081b46a9',
        //         studentNumber: '100',
        //         userDeviceMacId: 'bf:fc:e2:0e:93:e7',
        //         receivedAnswer: false,
        //         isTeacher: true,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46a7',
        //         studentNumber: '21',
        //         userDeviceMacId: '58:2f:be:86:1c:ee',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46a8',
        //         studentNumber: '22',
        //         userDeviceMacId: 'ef:3f:4d:11:ef:c7',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46aa',
        //         studentNumber: '3',
        //         userDeviceMacId: '26:05:e8:5b:ed:d1',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ab',
        //         studentNumber: '4',
        //         userDeviceMacId: '98:83:8f:a6:9c:fa',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ac',
        //         studentNumber: '5',
        //         userDeviceMacId: 'b5:de:e9:93:c5:c2',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ad',
        //         studentNumber: '6',
        //         userDeviceMacId: 'c9:ee:61:02:61:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ae',
        //         studentNumber: '7',
        //         userDeviceMacId: '28:56:46:47:b8:f4',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46af',
        //         studentNumber: '8',
        //         userDeviceMacId: '98:95:c3:0d:4b:fa',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b0',
        //         studentNumber: '9',
        //         userDeviceMacId: '39:76:8d:c4:b5:e3',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b1',
        //         studentNumber: '10',
        //         userDeviceMacId: 'ba:97:f2:01:91:ce',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b2',
        //         studentNumber: '11',
        //         userDeviceMacId: '05:d0:84:1f:a9:c9',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b3',
        //         studentNumber: '12',
        //         userDeviceMacId: 'bd:53:3b:30:15:ed',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b4',
        //         studentNumber: '13',
        //         userDeviceMacId: '7a:89:0f:87:42:eb',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b5',
        //         studentNumber: '14',
        //         userDeviceMacId: '72:87:f4:33:b9:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b6',
        //         studentNumber: '15',
        //         userDeviceMacId: '09:65:11:75:bd:de',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b7',
        //         studentNumber: '16',
        //         userDeviceMacId: '93:86:69:41:2f:fd',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b8',
        //         studentNumber: '17',
        //         userDeviceMacId: 'ca:b1:a7:e1:6c:dc',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b9',
        //         studentNumber: '18',
        //         userDeviceMacId: '17:0d:52:8c:8a:cb',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ba',
        //         studentNumber: '19',
        //         userDeviceMacId: '122',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46bb',
        //         studentNumber: '20',
        //         userDeviceMacId: '123',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46a7',
        //         studentNumber: '1',
        //         userDeviceMacId: '7c:0c:d3:ef:9b:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46a8',
        //         studentNumber: '2',
        //         userDeviceMacId: '65:05:df:31:dd:fe',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46aa',
        //         studentNumber: '3',
        //         userDeviceMacId: '26:05:e8:5b:ed:d1',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ab',
        //         studentNumber: '4',
        //         userDeviceMacId: '98:83:8f:a6:9c:fa',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ac',
        //         studentNumber: '5',
        //         userDeviceMacId: 'b5:de:e9:93:c5:c2',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ad',
        //         studentNumber: '6',
        //         userDeviceMacId: 'c9:ee:61:02:61:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ae',
        //         studentNumber: '7',
        //         userDeviceMacId: '28:56:46:47:b8:f4',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46af',
        //         studentNumber: '8',
        //         userDeviceMacId: '98:95:c3:0d:4b:fa',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b0',
        //         studentNumber: '9',
        //         userDeviceMacId: '39:76:8d:c4:b5:e3',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b1',
        //         studentNumber: '10',
        //         userDeviceMacId: 'ba:97:f2:01:91:ce',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b2',
        //         studentNumber: '11',
        //         userDeviceMacId: '05:d0:84:1f:a9:c9',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b3',
        //         studentNumber: '12',
        //         userDeviceMacId: 'bd:53:3b:30:15:ed',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b4',
        //         studentNumber: '13',
        //         userDeviceMacId: '7a:89:0f:87:42:eb',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b5',
        //         studentNumber: '14',
        //         userDeviceMacId: '72:87:f4:33:b9:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b6',
        //         studentNumber: '15',
        //         userDeviceMacId: '09:65:11:75:bd:de',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b7',
        //         studentNumber: '16',
        //         userDeviceMacId: '93:86:69:41:2f:fd',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b8',
        //         studentNumber: '17',
        //         userDeviceMacId: 'ca:b1:a7:e1:6c:dc',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b9',
        //         studentNumber: '18',
        //         userDeviceMacId: '17:0d:52:8c:8a:cb',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ba',
        //         studentNumber: '19',
        //         userDeviceMacId: '122',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46bb',
        //         studentNumber: '20',
        //         userDeviceMacId: '123',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46a7',
        //         studentNumber: '1',
        //         userDeviceMacId: '7c:0c:d3:ef:9b:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46a8',
        //         studentNumber: '2',
        //         userDeviceMacId: '65:05:df:31:dd:fe',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46aa',
        //         studentNumber: '3',
        //         userDeviceMacId: '26:05:e8:5b:ed:d1',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ab',
        //         studentNumber: '4',
        //         userDeviceMacId: '98:83:8f:a6:9c:fa',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ac',
        //         studentNumber: '5',
        //         userDeviceMacId: 'b5:de:e9:93:c5:c2',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ad',
        //         studentNumber: '6',
        //         userDeviceMacId: 'c9:ee:61:02:61:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ae',
        //         studentNumber: '7',
        //         userDeviceMacId: '28:56:46:47:b8:f4',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46af',
        //         studentNumber: '8',
        //         userDeviceMacId: '98:95:c3:0d:4b:fa',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b0',
        //         studentNumber: '9',
        //         userDeviceMacId: '39:76:8d:c4:b5:e3',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b1',
        //         studentNumber: '10',
        //         userDeviceMacId: 'ba:97:f2:01:91:ce',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b2',
        //         studentNumber: '11',
        //         userDeviceMacId: '05:d0:84:1f:a9:c9',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b3',
        //         studentNumber: '12',
        //         userDeviceMacId: 'bd:53:3b:30:15:ed',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b4',
        //         studentNumber: '13',
        //         userDeviceMacId: '7a:89:0f:87:42:eb',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b5',
        //         studentNumber: '14',
        //         userDeviceMacId: '72:87:f4:33:b9:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b6',
        //         studentNumber: '15',
        //         userDeviceMacId: '09:65:11:75:bd:de',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b7',
        //         studentNumber: '16',
        //         userDeviceMacId: '93:86:69:41:2f:fd',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b8',
        //         studentNumber: '17',
        //         userDeviceMacId: 'ca:b1:a7:e1:6c:dc',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b9',
        //         studentNumber: '18',
        //         userDeviceMacId: '17:0d:52:8c:8a:cb',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ba',
        //         studentNumber: '19',
        //         userDeviceMacId: '122',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46bb',
        //         studentNumber: '20',
        //         userDeviceMacId: '123',
        //         receivedAnswer: false,
        //     }
        // ],
        studentList: this.props.clickerUserList,
        isListening: false,
        selectedTab: 1,
        selectedText: 'A',
        showClassOneAllKeyPressScreen: true
    }

    tabs = [{ text: 'A', value: 1 },
    { text: 'B', value: 2 },
    { text: 'C', value: 3 },
    { text: 'D', value: 4 }
    ]

    constructor(props) {
        super(props)
        if (window.electron && window.electron.remoteControl) {
            this.handleStartListening()
        }

        console.log(this.props.selectedItem)

        if (window.AndroidClicker) {
            this.startScanning()
            this.handleStartListening()

        }
    }

    startScanning = () => {
        if (window.AndroidClicker) {
            console.log('scanning Started.......')
            window.AndroidClicker.startScanning(); // Calls native Android function
        } else {
            console.log("AndroidClicker interface not found!");
        }
    };

    stopScanning = () => {
        if (window.AndroidClicker) {
            console.log('scanning Stoped.......')
            window.AndroidClicker.stopScanning(); // Calls native Android function
        } else {
            console.log("AndroidClicker interface not found!");
        }
    };

    handleStartListening = () => {
        const { isListening } = this.state;

        if (window.electron && window.electron.remoteControl) {
            if (isListening) {
                this.setState({ isListening: false });
                window.electron.remoteControl.unsubscribeEvents();
                window.electron.remoteControl.close();
            } else {
                this.setState({ isListening: true });
                console.log('Opening remote control', window.electron.remoteControl.open);
                window.electron.remoteControl.open();

                window.electron.remoteControl.subscribeEvents((data) => {
                    console.log('Received data:', data);
                    // console.log(this.state.stopReceivingStudentSignal)

                    let studentList = this.state.studentList

                    let index = studentList.findIndex(item => item.userDeviceMacId === data.payload.id)

                    if (index != -1 && this.props.selectedItem.class != 'Class 1') {
                        // if (studentList[index].isTeacher && data.payload.value === 1) {
                        //     this.onClickNext()
                        // }
                        studentList[index].receivedAnswer = true
                    }


                    if (index != -1 && this.props.selectedItem.class === 'Class 1') {


                        if (this.state.showClassOneAllKeyPressScreen) {
                            if (studentList[index].isTeacher && data.payload.value === 1) {
                                this.onClickNext()
                            }
                                studentList[index].receivedAnswer = true
                            
                        } else {
                            if (studentList[index].isTeacher && data.payload.value === 1) {
                                this.onClickNext()
                            }

                            if (studentList[index].isTeacher && this.state.selectedTab === data.payload.value) {
                                studentList[index].receivedAnswer = true
                            }
                            if (this.state.selectedTab === data.payload.value) {
                                studentList[index].receivedAnswer = true
                            }
                        }
                    }





                    // console.log(this.state.studentList)
                    this.setState({ studentList })

                });
            }
            window.electron.ipcRenderer.once('ipc-example', (arg) => {
                // eslint-disable-next-line no-console
                console.log(arg);
            });
            window.electron.ipcRenderer.send('ipc-example', ['ping']);
        }

        if (window.AndroidClicker) {
            // Set up the global function to receive click events from WebView
            window.onClickEvent = (event) => {
                console.log("Click Event Received:", event);

                // Ensure the event is parsed from JSON if necessary
                let clickData = typeof event === "string" ? JSON.parse(event) : event;

                clickData.value += 1

                console.log(clickData)

                let studentList = this.state.studentList

                let index = studentList.findIndex(item => item.userDeviceMacId === clickData.id)

                if (index != -1) {
                    // if (studentList[index].isTeacher && clickData.value === 8) {

                    // }
                    studentList[index].receivedAnswer = true
                }

                // console.log(this.state.studentList)
                this.setState({ studentList })

            };
        }


    };

    componentWillUnmount() {
        // Cleanup on component unmount
        if (window.electron && window.electron.remoteControl) {
            window.electron.remoteControl.unsubscribeEvents();
            window.electron.remoteControl.close();
        }

        if (window.AndroidClicker) {
            this.stopScanning()
        }

    }

    onClickBack() {
        this.props.delegate && this.props.delegate.hideStudentClickerList && this.props.delegate.hideStudentClickerList()
    }

    goBacktoClickerPraticeListScreen() {
        this.props.delegate && this.props.delegate.onClickBack && this.props.delegate.onClickBack()
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props?.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props?.selectedItem?.section || ""} >`}</span>
                {
                    this.props.selectedItem.type === 'CLICKER_ASSESSMENT' ?
                        <span className='pl-2'>{this.getChapterNames(this.props.selectedItem?.chapters)} {`>`}</span>
                        :
                        <span className='pl-2'>{`${this.props?.selectedItem?.chapter} >`}</span>
                }
                {
                    CommonUtils.isOnline() ?
                        <span className='pl-2'>{this.getDate(this.props?.selectedItem?.createdDateTimestamp)}</span>
                        :
                        <span className='pl-2'>{this.props?.selectedItem?.createdDateTimestamp ? this.props?.selectedItem?.createdDateTimestamp : this.props?.selectedItem.createdDate ? this.props?.selectedItem.createdDate : ''}</span>
                }
            </div>
        )
    }

    handleMouseEnter = (studentNumber) => {
        this.setState({ hoveredStudent: studentNumber });
    };

    handleMouseLeave = () => {
        this.setState({ hoveredStudent: null });
    };

    getTextWidth(text, font = '28px Arial') {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = font; // Set font (must match your usage)
        console.log(context.measureText(text).width)
        return context.measureText(text).width; // Width in pixels
    }

    onClickNext() {

        let studentList = this.state.studentList

        studentList.forEach(item => {
            item.receivedAnswer = false
        })


        if (this.state.showClassOneAllKeyPressScreen) {
            this.setState({ showClassOneAllKeyPressScreen: false, studentList })
            return
        }


        if (this.tabs.length != this.state.selectedTab) {
            let selectedText = this.state.selectedText
            if (this.state.selectedTab + 1 === 2) {
                selectedText = 'B'
            }

            if (this.state.selectedTab + 1 === 3) {
                selectedText = 'C'
            }

            if (this.state.selectedTab + 1 === 4) {
                selectedText = 'D'
            }

            this.setState({ selectedTab: this.state.selectedTab + 1, studentList, selectedText })
        } else {
            this.setState({ selectedTab: 1, studentList, selectedText: 'A', showClassOneAllKeyPressScreen : true })
        }

    }



    render() {
        return (
            <div className="student-clicker-list">
                <div className='mb-3 item1'>
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>
                <div className='d-flex align-items-center justify-content-between header-report-card mb-1'>
                    <div className='d-flex align-items-center'>
                        <div>
                            <img className='circle-image' src={getImageSource(ImageConstants.RECOMMENDATION_REPORT_CIRCLE)} />
                        </div>
                        <div className='ml-2'>
                            <div className=''>
                                <span className='screen-title-1'>Clicker Testing - {this.props.setName}</span>
                                <span>{this.renderBreadcrumb()}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="header-for-practice-question">
                    <div className="sub-header-text">{"Clicker Testing"}</div>
                </div> */}

                <div className="d-flex align-items-center button-wrapper mt-4 mb-4">
                    {
                        this.state.studentList && this.state.studentList.length ?
                            this.state.studentList.map(student => (
                                student.isTeacher ?
                                    <div className="position-relative">
                                        <div className="cursor-pointer" onMouseEnter={() => this.handleMouseEnter(student.studentNumber)}
                                            onMouseLeave={this.handleMouseLeave}>
                                            {
                                                this.props.isReadOnly ?
                                                    <div
                                                        className={`teacher-roll-number-button ml-4 mb-4 ${student.receivedAnswer && student.isCorrect ? 'enable-button' :
                                                            student.receivedAnswer && !student.isCorrect ? "incorrect-button" : 'not-answered-button'}`}>{"Test Teacher Clicker"}
                                                    </div>
                                                    :
                                                    <div
                                                        className={`teacher-roll-number-button ml-4 mb-2 ${student.receivedAnswer ? 'enable-button' : ''}`}>{"Test Teacher Clicker"}
                                                    </div>
                                            }

                                        </div>
                                        {this.state.hoveredStudent === student.studentNumber && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: "-50px", // Align at the bottom
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    fontSize: "28px",
                                                    color: "blue",
                                                    zIndex: '999999',
                                                    width: this.getTextWidth("Test Teacher Clicker") + 30
                                                }}
                                                className="student-name"
                                            >
                                                {"Test Teacher Clicker"}
                                            </div>
                                        )}
                                    </div> :
                                    <></>
                            ))
                            :
                            <>No Students Found</>
                    }
                </div>


                {
                    this.props.selectedItem.class === 'Class 1' ?

                        <>
                            {
                                this.state.showClassOneAllKeyPressScreen ?
                                    <></>
                                    :
                                    <div className="press-text">Press {this.state.selectedText}</div>
                            }


                            <div className="d-flex align-items-center button-wrapper mt-4">
                                {
                                    this.state.studentList && this.state.studentList.length ?
                                        this.state.studentList.map(student => (
                                            student.isTeacher ?
                                                <></> :
                                                // <div className={`student-roll-number-button ml-4 mb-4 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}</div>
                                                <div className="position-relative">
                                                    <div className="cursor-pointer" onMouseEnter={() => this.handleMouseEnter(student.studentNumber)}
                                                        onMouseLeave={this.handleMouseLeave}>
                                                        {
                                                            this.props.isReadOnly ?
                                                                <div
                                                                    className={`student-roll-number-button ml-4 mb-4 ${student.receivedAnswer && student.isCorrect ? 'enable-button' :
                                                                        student.receivedAnswer && !student.isCorrect ? "incorrect-button" : 'not-answered-button'}`}>{student.studentNumber}
                                                                </div>
                                                                :
                                                                <div
                                                                    className={`student-roll-number-button ml-4 mb-2 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}
                                                                </div>
                                                        }

                                                    </div>
                                                    {this.state.hoveredStudent === student.studentNumber && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                bottom: "-50px", // Align at the bottom
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                fontSize: "28px",
                                                                color: "blue",
                                                                zIndex: '999999',
                                                                width: this.getTextWidth(student.userName) + 30
                                                            }}
                                                            className="student-name"
                                                        >
                                                            {student.userName}
                                                        </div>
                                                    )}
                                                </div>
                                        ))
                                        :
                                        <>No Students Found</>
                                }
                            </div>
                        </>


                        :

                        <div className="d-flex align-items-center button-wrapper mt-4">
                            {
                                this.state.studentList && this.state.studentList.length ?
                                    this.state.studentList.map(student => (
                                        student.isTeacher ?
                                            <></> :
                                            // <div className={`student-roll-number-button ml-4 mb-4 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}</div>
                                            <div className="position-relative">
                                                <div className="cursor-pointer" onMouseEnter={() => this.handleMouseEnter(student.studentNumber)}
                                                    onMouseLeave={this.handleMouseLeave}>
                                                    {
                                                        this.props.isReadOnly ?
                                                            <div
                                                                className={`student-roll-number-button ml-4 mb-4 ${student.receivedAnswer && student.isCorrect ? 'enable-button' :
                                                                    student.receivedAnswer && !student.isCorrect ? "incorrect-button" : 'not-answered-button'}`}>{student.studentNumber}
                                                            </div>
                                                            :
                                                            <div
                                                                className={`student-roll-number-button ml-4 mb-2 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}
                                                            </div>
                                                    }

                                                </div>
                                                {this.state.hoveredStudent === student.studentNumber && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            bottom: "-50px", // Align at the bottom
                                                            left: "50%",
                                                            transform: "translateX(-50%)",
                                                            fontSize: "28px",
                                                            color: "blue",
                                                            zIndex: '999999',
                                                            width: this.getTextWidth(student.userName) + 30
                                                        }}
                                                        className="student-name"
                                                    >
                                                        {student.userName}
                                                    </div>
                                                )}
                                            </div>
                                    ))
                                    :
                                    <>No Students Found</>
                            }
                        </div>

                }




                <div className="d-flex justify-content-center">
                    <div className="mt-3 button-wrapper-for-finish-button cursor-pointer" onClick={() => this.goBacktoClickerPraticeListScreen()}>
                        <div className="start-button">Testing Completed</div>
                    </div>
                    {
                        this.props.selectedItem.class === 'Class 1' && this.tabs.length != this.state.selectedTab ?
                            <div className="mt-3 button-wrapper-for-next-button cursor-pointer" onClick={() => this.onClickNext()}>
                                <div className="next-button">Next</div>
                            </div>
                            :
                            <></>
                    }

                </div>



            </div>
        )
    }

}

export default StudentClickerList;